export const SET_CURRENT_DATA_PRIVACY_TERMS = 'SET_CURRENT_DATA_PRIVACY_TERMS';
